import React, { useState, useRef } from 'react'
import styled from 'styled-components'
import Preview from './Preview'
import EditTable from './EditTable'
import { withRouter } from 'react-router-dom'
import RandomBox from './RandomBox'
import LoadingSpinner from '../Common/Loading/LoadingSpinner'
import { DropdownButton, Dropdown } from 'react-bootstrap'

const FreePerksComponent = props => {
  const {
    getPerks,
    isLoading,
    randomboxList,
    onboardingList,
    randomEdit,
    setRandomEdit,
  } = props

  const randomEditRef = useRef()
  const onboardingEditRef = useRef()

  const [lang, setLang] = useState('ja')

  return (
    <div style={{ minHeight: '100%' }}>
      <section className="content-header">
        <h1>Free Perks 관리</h1>
        <ol className="breadcrumb">
          <li>
            <a href="/Claude">
              <i className="fa fa-dashboard"></i>Free Perks
            </a>
          </li>
        </ol>
      </section>
      <section className="content">
        <div className="row">
          <section className="col-lg-12 connectedSortable">
            <div className="box box-info">
              {/* <div
                className="box-header with-border"
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'start',
                  alignItems: 'center',
                }}
              ></div> */}
              <div
                className="box-body"
                style={{
                  display: 'flex',
                  minHeight: 'calc(100dvh - 150px)',
                  maxHeight: 'calc(100dvh - 150px)',
                }}
              >
                <Preview />
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <Title>
                    Random Box
                    <ButtonWrapper>
                      <button
                        style={{ backgroundColor: '#007ffb' }}
                        onClick={() => {
                          if (randomEdit) {
                            randomEditRef.current.clickSave()
                          } else {
                            setRandomEdit(true)
                          }
                        }}
                      >
                        {randomEdit ? '저장' : '수정'}
                      </button>
                      {randomEdit && (
                        <button
                          style={{ backgroundColor: '#dc143c' }}
                          onClick={() => {
                            setRandomEdit(false)
                            getPerks()
                          }}
                        >
                          취소
                        </button>
                      )}
                    </ButtonWrapper>
                  </Title>
                  {isLoading ? (
                    <LoadingSpinner />
                  ) : (
                    <RandomBox
                      ref={randomEditRef}
                      randomboxList={randomboxList}
                      getPerks={getPerks}
                      edit={randomEdit}
                      setEdit={setRandomEdit}
                    />
                  )}
                  <Title>
                    Onboarding Gift
                    <ButtonWrapper>
                      <DropdownButton
                        variant="dark"
                        id="commit-status-dropdown"
                        title={lang}
                      >
                        {[
                          'ko',
                          'en',
                          'ja',
                          'ru',
                          'pt',
                          'es',
                          'id',
                          'zh-TW',
                          'ms',
                          'vi',
                          'ar',
                          'hi',
                        ].map((p, i) => {
                          return (
                            <Dropdown.Item key={i} onClick={() => setLang(p)}>
                              {p}
                            </Dropdown.Item>
                          )
                        })}
                      </DropdownButton>
                      <button
                        style={{ backgroundColor: '#007ffb' }}
                        onClick={() => {
                          props.history.push('/Perks/Edit', { item: {} })
                        }}
                      >
                        추가
                      </button>
                      <button
                        style={{ backgroundColor: '#dc143c' }}
                        onClick={() => {
                          onboardingEditRef.current.clickDelete()
                        }}
                      >
                        선택 삭제
                      </button>
                    </ButtonWrapper>
                  </Title>
                  {isLoading ? (
                    <LoadingSpinner />
                  ) : (
                    <EditTable
                      ref={onboardingEditRef}
                      history={props.history}
                      getPerks={getPerks}
                      onboardingList={onboardingList}
                      lang={lang}
                    />
                  )}
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    </div>
  )
}
export default withRouter(FreePerksComponent)

const Title = styled.div`
  font-size: 20px;
  margin: 10px 0 10px 10px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  column-gap: 5px;

  button {
    height: 35px;
    padding: 0 10px;
    box-sizing: border-box;
    color: #fff;
    border-radius: 5px;
    border: none;
    font-size: 16px;

    &:hover {
      opacity: 0.8;
      font-weight: bold;
    }
  }
`
